import { ADMIN, MODERATOR, SENIOR_MANAGER, MANAGER } from './roles';

export const ROLES = [
    { id: ADMIN, value: 'Администратор', color: 'green' },
    { id: MODERATOR, value: 'Модератор', color: 'blue' },
    { id: SENIOR_MANAGER, value: 'Старший менеджер', color: 'red' },
    { id: MANAGER, value: 'Менеджер', color: 'orange' }
];
